import type { NexReconciliationIdentifierMode } from './invoiceNexIdentifierUi';

export interface ResolveNexSubmitReferenceInput {
    mode?: NexReconciliationIdentifierMode | null;
    roNumber?: string | null;
    purchaseOrderNumber?: string | null;
    shopRoNumber?: string | null;
}

function trimRef(value: string | null | undefined): string {
    return String(value ?? '').trim();
}

/** Any identifier present (submit eligibility, list display). */
export function resolveNexSubmitReference(input: ResolveNexSubmitReferenceInput): string {
    const ro = trimRef(input.roNumber);
    const po = trimRef(input.purchaseOrderNumber);
    const shopRo = trimRef(input.shopRoNumber);
    const mode = input.mode ?? 'ro';

    if (mode === 'po') {
        return po || ro;
    }
    if (mode === 'both') {
        return shopRo || po || ro;
    }
    return ro;
}

/** Shop RO folder for NEX `/purchasing/orders` contactId — not the PO header id in both-mode. */
export function resolveNexRoContactId(input: ResolveNexSubmitReferenceInput): string {
    const ro = trimRef(input.roNumber);
    const po = trimRef(input.purchaseOrderNumber);
    const shopRo = trimRef(input.shopRoNumber);
    const mode = input.mode ?? 'ro';

    if (mode === 'both') {
        if (shopRo) return shopRo;
        if (ro && (!po || ro !== po)) return ro;
        return '';
    }
    if (mode === 'po') {
        return ro;
    }
    return ro;
}
